<div class="icon-word-list">
  <div *ngFor="let pair of imageAndIcons" class="icon-word-pair">
    <div class="image-background">
      <img *ngIf="pair.icon" class="smiley-img" src="{{ pair.icon }}" alt="smiley for {{ pair.word }}" />
    </div>
    <svg-icon
      *ngIf="!pair.icon"
      class="smiley-svg-icon"
      src="/assets/icons/smiley-meh.svg"
      [attr.aria-label]="'smiley for ' + pair.word"></svg-icon>
    <p class="text">{{ pair.word }}</p>
  </div>
</div>
